import React, { FC, useMemo } from "react";
import { Avatar, Button, Modal, Row, Typography } from "antd";
import { IncognitoIcon } from "@dewo/app/components/icons/Incognito";
import Link from "next/link";
import { RoleTag } from "../tags/RoleTag";
import { useOrganization } from "@dewo/app/containers/organization/hooks";
import { useRolesWithAccess } from "@dewo/app/containers/rbac/hooks";
import { ConnectUsingDiscordRolesButton } from "@dewo/app/containers/auth/buttons/ConnectUsingDiscordRolesButton";

interface Props {
  visible: boolean;
  workspaceId?: string;
  organizationId?: string;
}

export const WorkspaceAccessDeniedModal: FC<Props> = ({
  visible,
  workspaceId,
  organizationId,
}) => {
  const organization = useOrganization(organizationId);
  const roles = useRolesWithAccess(organizationId, workspaceId);
  const organizationRoles = useMemo(
    () => roles?.filter((r) => !r.userId),
    [roles]
  );
  return (
    <Modal
      visible={visible}
      footer={null}
      style={{ textAlign: "center" }}
      closable={false}
    >
      <Avatar
        icon={<IncognitoIcon style={{ width: 72, height: 72 }} />}
        size={96}
        style={{ display: "grid", placeItems: "center" }}
        className="mx-auto"
      />
      <Typography.Title level={4} style={{ marginTop: 16 }}>
        Access denied
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        You don't have access to this workspace.
        {!!organizationRoles?.length &&
          " The following roles can access this workspace:"}
      </Typography.Paragraph>
      {!!organizationRoles?.length && (
        <Row style={{ justifyContent: "center", marginBottom: 16, rowGap: 4 }}>
          {organizationRoles.map((role) => (
            <RoleTag key={role.id} role={role} />
          ))}
        </Row>
      )}
      <Row style={{ gap: 8, justifyContent: "center" }}>
        {!!organization ? (
          <Link href={organization.permalink}>
            <a>
              <Button>Go to DAO page</Button>
            </a>
          </Link>
        ) : (
          <Link href="/">
            <a>
              <Button>Go Home</Button>
            </a>
          </Link>
        )}
        {!!organizationId && (
          <ConnectUsingDiscordRolesButton
            type="primary"
            workspaceId={workspaceId}
            organizationId={organizationId}
            children="Connect with Discord"
          />
        )}
      </Row>
    </Modal>
  );
};
